<script setup lang="ts">
import Entry from './Entry.vue';
import { BACKEND_URL } from '@/services/apiClient';
import { useAuthStore } from '@/stores/auth';
import { onMounted, onUnmounted } from 'vue';
import { useI18n } from 'vue-i18n';

const { t: $t } = useI18n();
const authStore = useAuthStore();

onMounted(() => {
  document.body.style.overflow = 'hidden';
  document.documentElement.style.overflow = 'hidden';
});

onUnmounted(() => {
  document.body.style.overflow = '';
  document.documentElement.style.overflow = '';
});
</script>

<template>
  <div class="public-entry-root">
    <div class="public-entry-details" v-if="authStore.userData">
      {{ $t("submitting_entry_as") }}
      <img :src="`${BACKEND_URL}${authStore.userData?.avatar}`"
        class="avatar"/>
      {{ authStore.userData?.name }}
    </div>

    <Entry />
  </div>
</template>

<style scoped lang="scss">
.public-entry-root {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100svh;
}
.public-entry-details {
  width: 100%;
  max-width: 1080px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 16px 48px 0px;
}
.avatar {
  width: 24px;
  margin-left: 8px;
  margin-right: 8px;
  border-radius: 4px;
}
:deep(.entry-root) {
  height: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
:deep(.entry-root-without-navigation) {
  padding-top: 20px;
}
</style>
